import { render, staticRenderFns } from "./OrderPaymentTimeout.vue?vue&type=template&id=1ae762a8&scoped=true"
import script from "./OrderPaymentTimeout.vue?vue&type=script&lang=js"
export * from "./OrderPaymentTimeout.vue?vue&type=script&lang=js"
import style0 from "./OrderPaymentTimeout.vue?vue&type=style&index=0&id=1ae762a8&prod&lang=scss"
import style1 from "./OrderPaymentTimeout.vue?vue&type=style&index=1&id=1ae762a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae762a8",
  null
  
)

export default component.exports